import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import NotificationSnackbar, { NotificationType } from 'components/common/NotificationSnackBar';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import JournalistFilters from '../features/journalists/components/JournalistFilters';
import JournalistsTable from '../features/journalists/components/JournalistsTable';
import { fetchJournalists } from '../features/journalists/slices/journalistsSlice';

const JournalistsPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading, error } = useSelector((state: RootState) => state.journalists);
  
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    type: 'info' as NotificationType,
  });

  useEffect(() => {
    const loadJournalists = async () => {
      try {
        await dispatch(fetchJournalists());
      } catch (err) {
        setNotification({
          open: true,
          message: 'Failed to load journalists',
          type: 'error',
        });
      }
    };
    
    loadJournalists();
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      setNotification({
        open: true,
        message: error,
        type: 'error',
      });
    }
  }, [error]);

  const closeNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Journalist Management
      </Typography>
      <Typography variant="body1" paragraph>
        Manage journalists for your publications. Each journalist now belongs to a single publisher.
        Use the filters to view by publisher, and the form to create or edit a journalist including
        selecting their publisher.
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <JournalistFilters />
      </Paper>
      
      {isLoading && !error ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <JournalistsTable />
      )}
      
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        type={notification.type}
        onClose={closeNotification}
      />
    </Box>
  );
};

export default JournalistsPage;